import styled from '@emotion/styled';
import { getTextColor } from '../../style';
import { IHeadlineProps } from './types/Headline';
import breakpoints from '../../theme/material/breakpoints';

const sizes = {
  XS: 16,
  SM: 18,
  MD: 22,
  LG: 28,
  XL: 32,
};

const Headline = styled('h1')<IHeadlineProps>(
  () => ({
    margin: 0,
    fontWeight: 'normal',
    ...getTextColor().BRAND,
  }),
  ({ size = 'MD', breakPointSize = 'SM' }) => ({
    fontSize: sizes[size],
    [breakpoints.down(768.05)]: { fontSize: sizes[breakPointSize] },
  }),
  ({ spaceAfter }) => ({ marginBottom: spaceAfter ? 16 : 0 }),
  ({ spacedMobile }) => {
    if (spacedMobile === true) {
      return {
        [breakpoints.down(479.05)]: {
          padding: '0 22px',
        },
      };
    }
  }
);

export default Headline;
